export const testIfStringOnlyHasNumber = (val: string) => {
  return /\d/.test(val);
};
